import React from "react";

import { Button } from "../../../../../atoms";

export const GetInTouchButton: React.FC = () => (
  <Button background="blue" size="medium" href="https://ruuby.typeform.com/to/HvHs1GrF" target="_blank">
    Get in touch with us
  </Button>
);
